/*
 * <event-date-buy> — inline "quick book" for the event-dates list.
 *
 * Reuses Dawn's real product form: on first open it fetches the date's
 * product page, lifts out the <product-info> element (exactly like
 * quick-add.js), rewrites its section id to a unique token so multiple
 * open panels never collide, hides the media/title, and injects it below
 * the row. product-info.js / product-form.js are loaded on the collection
 * page (see event-dates.liquid) so the injected element hydrates itself —
 * the variant picker and add-to-cart are Dawn's, untouched.
 */
if (!customElements.get('event-date-buy')) {
  customElements.define(
    'event-date-buy',
    class EventDateBuy extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('[data-buy-toggle]');
        this.panel = this.querySelector('[data-buy-panel]');
        this.loaded = false;
        if (this.toggle) this.toggle.addEventListener('click', this.onToggle.bind(this));
      }

      onToggle() {
        const open = this.classList.toggle('is-open');
        this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.panel.hidden = !open;
        if (open && !this.loaded) this.load();
      }

      load() {
        this.loaded = true;
        this.classList.add('is-loading');
        fetch(this.dataset.productUrl)
          .then((r) => r.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const el = doc.querySelector('product-info');
            if (!el) throw new Error('no product-info');
            this.preprocess(el);
            this.panel.innerHTML = el.outerHTML;
            if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
          })
          .catch(() => {
            this.loaded = false; // allow a retry on next open
            this.panel.innerHTML =
              '<p class="event-dates__buy-error">読み込みに失敗しました。もう一度お試しください。</p>';
          })
          .finally(() => this.classList.remove('is-loading'));
      }

      preprocess(el) {
        // Unique section-id token so multiple panels (same template = same
        // section id) don't produce duplicate element IDs on the page.
        const oldId = el.dataset.section;
        const newId = `evbuy-${this.dataset.productId}`;
        el.innerHTML = el.innerHTML.replaceAll(oldId, newId);
        Array.from(el.attributes).forEach((a) => {
          if (a.value.includes(oldId)) el.setAttribute(a.name, a.value.replace(oldId, newId));
        });
        // product-info.js re-fetches the section on variant change using
        // sectionId = originalSection || section. Keep the real id here so
        // that fetch hits a real section and the price/availability update.
        el.dataset.originalSection = oldId;

        // Don't rewrite the browser URL on variant change; it's not the main product.
        el.setAttribute('data-update-url', 'false');

        // Drop elements that don't belong inline. The media gallery is
        // removed (not just hidden) because <media-gallery> scrolls the whole
        // window to its active media on hydrate/variant-change — which yanks
        // the page up to a previous section. product-info.js guards for a
        // missing gallery, so the variant picker + add-to-cart still work.
        // Keep inline JSON scripts — product-info.js reads variant data from them.
        // Also drop injected <style> blocks: the product template's main section
        // ships a custom_liquid <style> with a two-column float (section[id$=
        // "__event_details"]{float:left...}) that would leak onto this page and
        // shove the layout side-by-side. Styles aren't scoped, so they must go.
        el.querySelectorAll(
          '.product__media-wrapper, media-gallery, pickup-availability, product-modal, modal-dialog, script[src], style'
        ).forEach((n) => n.remove());
      }
    }
  );
}
